import React from "react";
import AsciiFluidSimulation from "./AsciiFluidSimulation";
import AssistantVideo from "./AssistantVideo";
import { useTheme } from "../context/ThemeContext";
import { useT } from "../context/LanguageContext";
import { Phone, ArrowRight } from "lucide-react";
import "./Hero.css";

const Hero = ({ onTalkAgent, onGetStarted }) => {
  const { theme } = useTheme();
  const t = useT();
  return (
    <section
      id="top"
      className="hero-assistant relative w-full overflow-hidden"
      style={{
        height: "100svh",
        background: theme === "dark"
          ? "radial-gradient(ellipse at center, #0B112C 0%, #060918 60%, #03040A 100%)"
          : "radial-gradient(ellipse at center, #FBFCFF 0%, #EBEFFA 60%, #D9E0F2 100%)"
      }}
    >
      <div className="absolute inset-0">
        <AsciiFluidSimulation theme={theme} />
      </div>

      <div className="relative h-full flex flex-col items-center pt-24 sm:pt-20 pb-9 sm:pb-6 px-6 pointer-events-none">
        {/* Upper section: Title */}
        <div className="flex flex-col items-center w-full mt-2 sm:mt-0">
          <h1
            className="fade-in mt-4 text-center font-bold tracking-tight leading-[1.1]"
            style={{ color: "var(--fg)", fontSize: "clamp(1.8rem, 4vw, 3.5rem)", animationDelay: "0.2s", maxWidth: 1000 }}
          >
            {t("hero.title1")}
            {t("hero.title2") ? <> <span className="brand-gradient-text">{t("hero.title2")}</span></> : null}
            {t("hero.title3") ? <><br />{t("hero.title3")}</> : null}
          </h1>
        </div>

        {/* Keep the portrait clear of both the heading and the controls. */}
        <div className="relative flex-1 min-h-[340px] w-full my-3">
          <AssistantVideo theme={theme} />
        </div>

        {/* Lower section: Subtitle & Buttons */}
        <div className="flex flex-col items-center w-full">
          
          <div className="fade-in flex flex-col sm:flex-row items-center gap-3 pointer-events-auto" style={{ animationDelay: "0.5s" }}>
            <button
              onClick={onTalkAgent}
              className="neon-btn inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-[14px] font-semibold"
            >
              <Phone size={16} /> {t("hero.cta.talk")}
            </button>
            <button
              onClick={onGetStarted}
              className="neon-btn neon-btn-coral inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-[14px] font-semibold"
            >
              {t("hero.cta.start")} <ArrowRight size={16} />
            </button>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Hero;
